import { render, staticRenderFns } from "./economicsHistory.vue?vue&type=template&id=db6fa1bc"
import script from "./economicsHistory.vue?vue&type=script&lang=js"
export * from "./economicsHistory.vue?vue&type=script&lang=js"
import style0 from "./economicsHistory.vue?vue&type=style&index=0&id=db6fa1bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports